<div class="tab">
    <mat-tab-group
        (selectedTabChange)="tabActivated($event)"
        ActiveTabIndex="selectedTab"
        class="settings"
        id="tab-bar"
    >
        <mat-tab *ngFor="let tab of tabs" [label]="tab.label" class="settings"></mat-tab>
    </mat-tab-group>
</div>
